import { Link, useLocation } from "react-router-dom";
import { Home, Search, ShoppingBag, Truck, User } from "lucide-react";
import { useCart } from "@/context/CartContext";

const ITEMS = [
    { to: "/", label: "Home", icon: Home, key: "home" },
    { to: "/shop", label: "Shop", icon: Search, key: "shop" },
    { to: "/cart", label: "Cart", icon: ShoppingBag, key: "cart" },
    { to: "/track-order", label: "Track", icon: Truck, key: "track" },
    { to: "/contact", label: "Contact", icon: User, key: "contact" },
];

export default function MobileBottomBar() {
    const { pathname } = useLocation();
    const { totals } = useCart();

    return (
        <nav
            className="fixed bottom-0 inset-x-0 z-30 md:hidden bg-[#0A0A0B]/95 backdrop-blur-xl border-t border-[#27272A]"
            data-testid="mobile-bottom-bar"
        >
            <div className="grid grid-cols-5">
                {ITEMS.map((it) => {
                    const Icon = it.icon;
                    const active = pathname === it.to || (it.to !== "/" && pathname.startsWith(it.to));
                    return (
                        <Link
                            key={it.key}
                            to={it.to}
                            className={`flex flex-col items-center justify-center py-2.5 text-[11px] uppercase tracking-widest font-display font-semibold ${
                                active ? "text-[#00BCE5]" : "text-white/55"
                            }`}
                            data-testid={`mbb-${it.key}`}
                        >
                            <div className="relative">
                                <Icon size={20} strokeWidth={active ? 2.5 : 2} />
                                {it.key === "cart" && totals.count > 0 && (
                                    <span className="absolute -top-1.5 -right-2.5 bg-[#00BCE5] text-black text-[9px] font-black rounded-full px-1">
                                        {totals.count}
                                    </span>
                                )}
                            </div>
                            <span className="mt-0.5">{it.label}</span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
}
